import { render, staticRenderFns } from "./HistoryPayment.vue?vue&type=template&id=4f551d3d&"
import script from "./HistoryPayment.vue?vue&type=script&lang=js&"
export * from "./HistoryPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports